import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Rastreo } from '../entidades/rastreo';
import { ColoniasDspEntDm } from '../entidades/solicitud';
import { Ciudades } from '../entidades/ciudades';
import { Estados } from '../entidades/estados';

@Injectable({
  providedIn: 'root'
})
export class RastreoService {

  constructor(
    private http: HttpClient
  ) { }

  private paquetesSource = new BehaviorSubject(new Rastreo);
  paquetes = this.paquetesSource.asObservable();

  private rastreoSeleccionadoSource = new BehaviorSubject(new Rastreo);
  rastreoSeleccionado = this.rastreoSeleccionadoSource.asObservable();

  private coloniasSource = new BehaviorSubject([]);
  colonias = this.coloniasSource.asObservable();

  private ciudadesSource = new BehaviorSubject([]);
  ciudades = this.ciudadesSource.asObservable();

  private estadosSource = new BehaviorSubject([]);
  estados = this.estadosSource.asObservable();

  track_pack(codigo){
    // let url = `${environment.URL_API_ALFA}/commdatosenvio?codigo=${codigo}&push=-`
    let url = `${environment.URL_API}/commdatosenvio?codigo=${codigo}&push=-`
    return this.http.get(url);
  }

  save_packs(paquetes){
    this.paquetesSource.next(paquetes);
  }

  clean_packs(){
    this.paquetesSource.next(new Rastreo);
  }

  guardarRastreoSelected(rastreo: Rastreo) {
    this.rastreoSeleccionadoSource.next(rastreo);
  }

  obtenerDomicilios(codigo: string) {
    //// // console.log(codigo);
    let uri = `${environment.URL_API}/commColoniaValEntDm?rastreo=${codigo}`;

    if (!environment.production) { uri += '&isTestMode=true'; }

    return this.http.get<ColoniasDspEntDm[]>(
      uri
    );
  }

  guardarColinias(colonias: ColoniasDspEntDm[]) {
    this.coloniasSource.next(colonias);
    let ciudad = '';
    let estado = '';
    const ciudades: Ciudades[] = [];
    const estados: Estados[] = [];

    colonias.forEach(colonia => {

      if (colonia.ciudad !== ciudad) {
        ciudades.push(new Ciudades(colonia.ciudad, colonia.idcd));
        ciudad = colonia.ciudad;
      }

      if (colonia.estado !== estado) {
        estados.push(new Estados(colonia.estado, colonia.idedo));
        estado = colonia.estado;
      }

    });

    this.ciudadesSource.next(ciudades);
    this.estadosSource.next(estados);
  }


    track_pack2(codigo){
     let url = `${environment.URL_APIALPHA}/commdatosenvio?codigo=${codigo}&push=-`
    // let url = `${environment.URL_API}/commdatosenvio?codigo=${codigo}&push=-`
    return this.http.get(url);
  }


    getDomicilios(codigo: string) {
    let uri = `${environment.URL_API_ALFA}/commColoniaValEntDm?rastreo=${codigo}`;
    return this.http.get<ColoniasDspEntDm[]>(uri);
  }

  // Alta de notificación (opr=ALT, idnotificacion=0)
  activarNotificacion(idcliente: number, tipo: string, referencia: string) {
    const url = `${environment.URL_APIPAQ_PROD}/oprConfigNotificaciones?opr=ALT&idcliente=${idcliente}&tipo=${tipo}&referencia=${referencia}&idnotificacion=0`;
    return this.http.get<any>(url);
  }

  // Baja de notificación (opr=DEL, requiere idnotificacion)
  eliminarNotificacion(idcliente: number, idnotificacion: number) {
    const url = `${environment.URL_APIPAQ_PROD}/oprConfigNotificaciones?opr=DEL&idcliente=${idcliente}&tipo=&referencia=&idnotificacion=${idnotificacion}`;
    return this.http.get<any>(url);
  }

  // Obtener configuraciones (devuelve lista con Idnotificacion)
  obtenerConfigNotificaciones(idcliente: number | string) {
    const url = `${environment.URL_APIPAQ_PROD}/obtenerConfigNotificaciones?idcliente=${idcliente}`;
    return this.http.get<any>(url);
  }

  obtenerTemasAsistencia() {
  let url = `${environment.URL_APIPAQ_PROD}/ObtenertemasAsistencia`;
  return this.http.get<any[]>(url);
  }

guardarSolicitudAsistencia(
  idcliente: number,
  nombre: string,
  correo: string,
  tel: string,
  idtema: number,          // ← ahora ID, no texto
  mensaje: string,
  rastreo: string          // ← nuevo parámetro
) {
  const url =
    `${environment.URL_APIPAQ_PROD}/oprSolicitudAsistencia` +
    `?opr=ALT&idcliente=${idcliente}` +
    `&nombre=${encodeURIComponent(nombre)}` +
    `&correo=${encodeURIComponent(correo)}` +
    `&tel=${encodeURIComponent(tel)}` +
    `&idtema=${idtema}` +
    `&mensaje=${encodeURIComponent(mensaje)}` +
    `&rastreo=${encodeURIComponent(rastreo)}`;

  return this.http.get<{ Text: string }>(url);
}

// rastreo.service.ts
getDomiciliosListPorEdoCd(idcliente: number, idedo: number, idcd: number) {
  const url =
    `${environment.URL_APIPAQ_PROD}/ObtenerDireccionesCliente` +
    `?idcliente=${idcliente}&idedo=${idedo}&idcd=${idcd}`;
  return this.http.get<any[]>(url);
}

predeterminarDireccion(iddir: string, idcliente: string, rastreo: string) {
  const url =
    `${environment.URL_APIPAQ_PROD}/oprDireccionPredeterminar` +
    `?iddir=${iddir}&idcliente=${idcliente}&rastreo=${encodeURIComponent(rastreo)}`;
  return this.http.get<{ Text: string }>(url);
}

getColonias(idedo: number, idcd: number) {
  let url = `${environment.URL_APIPAQ_PROD}/obtenerColoniasrastreo?idedo=${idedo}&idcd=${idcd}`;
  return this.http.get<any[]>(url);
}

guardarDireccionALT(
  idcliente: number,
  iddir: number,            // 0 para alta
  idedo: number,
  idcd: number,
  idcol: number,
  nombre: string,
  correo: string,
  tel: string,
  direccion: string,
  referencia: string
) {
  const url = `${environment.URL_APIPAQ_PROD}/oprGuardarDireccion` +
              `?opr=ALT&idcliente=${idcliente}&iddir=${iddir}` +
              `&idedo=${idedo}&idcd=${idcd}&idcol=${idcol}` +
              `&nombre=${encodeURIComponent(nombre)}` +
              `&correo=${encodeURIComponent(correo)}` +
              `&tel=${encodeURIComponent(tel)}` +
              `&direccion=${encodeURIComponent(direccion)}` +
              `&referencia=${encodeURIComponent(referencia)}` +
              `&predeterminado=0`; // ← siempre 0

  return this.http.get<{ Text: string }>(url);
}

  eliminarDireccion(idcliente: number | string, iddir: number | string) {
  const url =
    `${environment.URL_APIPAQ_PROD}/oprGuardarDireccion` +
    `?opr=DEL&idcliente=${idcliente}&iddir=${iddir}` +
    `&idedo=0&idcd=0&idcol=0&nombre=&correo=&tel=&direccion=&referencia=&predeterminado=0`;
  return this.http.get<{ Text: string }>(url);
}

obtenerTemasIncidencia(tipo: string) {
  const url = `${environment.URL_APIPAQ_PROD}/ObtenertemasAsistencia?tipo=${encodeURIComponent(tipo)}`;
  return this.http.get<Array<{ idtema: number; tema: string }>>(url);
}

// Alta de incidencia
registrarIncidencia(rastreo: string | number, idusr: number, idtema: number, mensaje: string) {
  const url = `${environment.URL_APIPAQ_PROD}/OprIncidencia?opr=ALT&rastreo=${rastreo}&idusr=${idusr}&mensaje=${encodeURIComponent(mensaje)}&idtema=${idtema}`;
  return this.http.get<{ msg: string; num: string; ref: string }>(url);
}
// Alta de adjunto(s) de la incidencia
adjuntarIncidenciaALT(payload: {
  idmensaje: string | number;
  tipo: 'IMG';
  nombrearchivo: string;
  archivo: string;         // base64 SIN el prefijo data:
  idadjunto?: string | number; // default 0
}) {
  const url = `${environment.URL_APIPAQ_PROD}/OprIncidenciasAdjuntos`;
  const body = {
    opr: 'ALT',
    idadjunto: String(payload.idadjunto ?? '0'),
    idmensaje: String(payload.idmensaje),
    tipo: payload.tipo,
    nombrearchivo: payload.nombrearchivo,
    archivo: payload.archivo
  };
  return this.http.post<{ id: number; msg: string; ireferencia: number }>(url, body);
}

cargarIncidencia(idusr: number, rastreo: string | number) {
  const url = `${environment.URL_APIPAQ_PROD}/CargarIncidencia?idusr=${idusr}&rastreo=${rastreo}`;
  return this.http.get<{
    mensaje?: string;
    tema?: string;
    usuario?: string;
    fecha?: string;
    adjuntos?: Array<{ nombrearchivo?: string; archivo?: string; tipo?: string; urlarchivo?: string }>;
  }>(url);
}

enviarMensajeIncidencia(
  idincidencia: number,
  rastreo: string,
  idusr: number,
  mensaje: string
) {
  const url =
    `${environment.URL_APIPAQ_PROD}/OprMensajesIncidencia` +
    `?opr=ALT&idincidencia=${idincidencia}` +
    `&rastreo=${encodeURIComponent(rastreo)}` +
    `&idusr=${idusr}` +
    `&mensaje=${encodeURIComponent(mensaje)}`;

  return this.http.get<{ msg: string; num: string; ref: string }>(url);
}

cargarMensajesIncidencia(idusr: number, idincidencia: number) {
  const url =
    `${environment.URL_APIPAQ_PROD}/CargarMensajesIncidencia` +
    `?idusr=${idusr}&idincidencia=${idincidencia}`;
  return this.http.get<any[]>(url);
}


obtenerTemasMotivos() {
  const url = `${environment.URL_APIPAQ_PROD}/ObtenertemasMotivos`;
  return this.http.get<Array<{ idtema: number; tema: string }>>(url);
}

obtenerRangosHorarios() {
  const url = `${environment.URL_APIPAQ_PROD}/ObtenerRangosHorarios`;
  return this.http.get<Array<{ idtema: number; tema: string }>>(url);
}

reprogramarEntrega(
  rastreo: string,
  motivo: string,
  instr: string,
  rango: string,
  fechaYYYYMMDD: string
) {
  const url =
    `${environment.URL_APIPAQ_PROD}/oprreprogramarentrega` +
    `?rastreo=${encodeURIComponent(rastreo)}` +
    `&motivo=${encodeURIComponent(motivo)}` +
    `&instr=${encodeURIComponent(instr)}` +
    `&rango=${encodeURIComponent(rango)}` +
    `&fecha=${encodeURIComponent(fechaYYYYMMDD)}`;

  return this.http.get<{ Text: string }>(url);
}

obtenerProgramacion(rastreo: string) {
  const url = `${environment.URL_APIPAQ_PROD}/ObtenerProgramacion?rastreo=${encodeURIComponent(rastreo)}`;
  return this.http.get<{
    rastreo: number | string;
    motivo: string;
    instrucciones: string;
    rango: string;
    fecha: string; // YYYYMMDD
  }>(url);
}

// getPermisosEnvio(rastreo: string | number) {
//   const url = `${environment.URL_APIPAQ_PROD}/masdatosenvio?rastreo=${rastreo}`;
//   return this.http.get<any>(url);
// }

getPermisosEnvio(rastreo: string | number, idcliente: string | number) {
  const url = `${environment.URL_APIPAQ_PROD}/masdatosenvio?rastreo=${rastreo}&idcliente=${idcliente}`;
  return this.http.get<any>(url);
}

oprDatosReclamo(idincidencia: number | string, idusr: number | string, nombre: string,
  rfc: string, telefono: string, correo: string, contacto: string, idcon: string, telcon: string, correocon: string) {
  const url = `${environment.URL_APIPAQ_PROD}/OprDatosReclamo?idincidencia=${idincidencia}&idusr=${idusr}&nombre=${nombre}&rfc=${rfc}&telefono=${telefono}&correo=${correo}&contacto=${contacto}&idcon=${idcon}&telcon=${telcon}&correocon=${correocon}`;
  return this.http.get<any>(url);
}

  // NUEVO: subir adjunto
subirAdjuntoIncidencia(opr: 'ALT' | 'MOD' | 'BAJ', idadjunto: number | string, idmensaje: number | string, 
    tipo: 'CRT' | 'REM' | 'SEG' | 'INE' | 'FAC', nombrearchivo: string,archivoBase64: string) {
    const url = `${environment.URL_APIPAQ_PROD}/OprIncidenciasAdjuntos`;
    const body = {
      opr,
      idadjunto: String(idadjunto),
      idmensaje: String(idmensaje),
      tipo,
      nombrearchivo,
      archivo: archivoBase64
    };
    return this.http.post<any>(url, body);
  }
}




